<template>
  <main>
    <a @click.prevent="$router.go(-1)" href="#" class="link-back"><span class="icon-ico-arrow-left"></span> {{ navigationTitle }}</a>
    <FormReport v-model="data" @submit="onSubmit" ref="formReport" :disabled="isDetailPage" @on-delete="deleteReport" />
  </main>
</template>
<script>
import FormReport from "@/components/form/report"
import axios from '@/axios';
import { showErrorMessage } from '@/utils';

export default {
  components: {
    FormReport
  },
  data() {
    return {
      data: {
        name: '',
        link: '',
        category: ''
      },
    }
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.formReport.$validator.validateAll();
      if (isValid) {
        this.$store.dispatch('toggleLoadingProgress', true)
        axios.put(`/reports/${this.$route.params.id}`, this.data).then(() => {
          this.$notify({ type: 'success', text: 'Success updating report' })
          this.$router.push('/reports')
        }).catch(error => {
          showErrorMessage(error)
        }).finally(() => {
          this.$store.dispatch('toggleLoadingProgress', false)
        })
      }
    },
    deleteReport() {
      if (confirm('Are you sure you want to delete this data?')) {
        this.$store.dispatch('toggleLoadingProgress', true)
        axios.delete(`/reports/${this.$route.params.id}`)
          .then(() => {
            this.$notify({ type: 'success', title: 'Success', text: 'Success delete report' })
            this.$router.push('/reports')
          }).catch(error => {
            showErrorMessage(error)
          }).finally(() => {
            this.$store.dispatch('toggleLoadingProgress', false)
          })
      }
    },
  },
  async mounted() {
    this.$store.dispatch('toggleLoadingProgress', true)
    try {
      const { data } = await axios.get(`/reports/${this.$route.params.id}`)
      const report = data?.data

      if (report) {
        Object.assign(this.data, {
          name: report.name,
          link: report.link,
          category: report.category
        })
      }
    } catch (err) {
      showErrorMessage(err)
      this.$router.push('/reports')
    } finally {
      this.$store.dispatch('toggleLoadingProgress', false)
    }
  },
  computed: {
    isDetailPage() {
      return this.$route.name === 'DetailReport'
    },
    navigationTitle() {
      return this.isDetailPage ? 'Detail Report' : 'Edit Report'
    }
  }
}
</script>

<style></style>
